module.exports = __webpack_public_path__ + "static/media/banner.de73c826.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/payment-verification/banner.jpg
// module id = 1689
// module chunks = 0